export class DataTableCurrentDataEvent {
}
